/**
 * Build a deep link that opens the Transactions screen filtered to a single record.
 * The screen filters on the reference, so the numeric id is only a fallback.
 */
export function buildTransactionDeepLink(
  transactionReference?: string | null,
  transactionId?: string | number | null,
): string {
  const searchTerm = transactionReference || (transactionId == null ? '' : String(transactionId));
  return searchTerm ? `/transactions?search=${encodeURIComponent(searchTerm)}` : '/transactions';
}
